// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"153":"71d470ed","260":"3ee5f15a","668":"e4a40f3b","762":"b9bb746f"}[chunkId] + ".js";
};